(function () {
    document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href="#carry-on-video"]');

    if (link) {
        e.preventDefault();
        const button = document.querySelector('button[aria-label="Load video: Carry On Music Video"]');
        
        if (button) {
            button.click();
        }
    }
    });
})();

/* Add-to-cart reveals the header: the header auto-hides when you scroll down
   (sticky="scroll-up"). When an item is added to cart, slide it back into view so the
   cart icon and its updated count are visible — by switching it to the same
   data-sticky-state='active' state the theme uses when you scroll up. */
(function () {
  var header = document.querySelector('header-component');
  if (!header || header.getAttribute('sticky') !== 'scroll-up') return;

  document.addEventListener('cart:update', function (e) {
    var data = e.detail && e.detail.data;
    // Only on a successful add from a product form (not cart-drawer / quantity edits).
    if (!data || data.didError || data.source !== 'product-form-component') return;
    header.dataset.scrollDirection = 'up';
    header.dataset.stickyState = 'active';
  });
})();
